var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "container container--reviews yotpo-reviews__carousel-wrapper",
    },
    [
      _c(
        "div",
        { staticClass: "yotpo-reviews__carousel-nav" },
        [
          _c("icon-button", {
            staticClass: "carousel-nav__prev",
            attrs: {
              label: "Previous Slide",
              icon: _vm.$mq === "mobile" ? "chevron-left" : "chevron-left-big",
              size: _vm.$mq === "mobile" ? "16px" : "64px",
            },
            on: { click: _vm.slidePrev },
          }),
          _c("icon-button", {
            staticClass: "carousel-nav__next",
            attrs: {
              label: "Next Slide",
              icon: _vm.$mq === "mobile" ? "chevron-right" : "chevron-left-big",
              size: _vm.$mq === "mobile" ? "16px" : "64px",
            },
            on: { click: _vm.slideNext },
          }),
        ],
        1
      ),
      _vm.topReviews.length > 0
        ? _c(
            "carousel",
            {
              ref: "carousel",
              staticClass: "yotpo-reviews__carousel",
              attrs: {
                "slides-to-show": ["mobile", "tablet"].includes(_vm.$mq)
                  ? 1
                  : 3,
                "center-mode": true,
                infinite: true,
              },
            },
            _vm._l(_vm.topReviews, function (review, index) {
              return _c(
                "slide",
                {
                  key: review.id + index,
                  staticClass: "yotpo-reviews__review",
                },
                [
                  _c("div", { staticClass: "yotpo-reviews__review-header" }, [
                    _c(
                      "div",
                      { staticClass: "yotpo-reviews__review-avitar" },
                      [
                        _vm._v(_vm._s(review.user.display_name[0])),
                        _c("icon", {
                          staticClass: "yotpo-reviews__review-checkmark",
                          attrs: { name: "check", size: "18px" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "yotpo-reviews__review-buyer" },
                      [
                        _c(
                          "div",
                          { staticClass: "yotpo-reviews__review-buyer-info" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "yotpo-reviews__review-buyer-name",
                              },
                              [
                                _vm._v(_vm._s(review.user.display_name)),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "yotpo-reviews__review-buyer-verified",
                                  },
                                  [_vm._v("Verified Buyer")]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c("star-rating", {
                          staticClass: "yotpo-reviews__review-buyer-rating",
                          attrs: { rating: review.score },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("h3", { staticClass: "yotpo-reviews__review-title" }, [
                    _vm._v(_vm._s(review.title)),
                  ]),
                  _c("p", {
                    staticClass: "yotpo-reviews__review-contents",
                    domProps: { innerHTML: _vm._s(review.content) },
                  }),
                  _c("div", { staticClass: "yotpo-reviews__review-info" }, [
                    _c("div", { staticClass: "yotpo-reviews__review-date" }, [
                      _vm._v(_vm._s(_vm.cleanDate(review.created_at))),
                    ]),
                    _vm.displayRatings === "yes"
                      ? _c(
                          "div",
                          { staticClass: "yotpo-reviews__review-rating" },
                          [
                            _c("icon", {
                              attrs: {
                                name: "yotpo-thumbsup",
                                width: "24px",
                                height: "24px",
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "yotpo-reviews__review-rating-amount",
                              },
                              [_vm._v(_vm._s(review.votes_up))]
                            ),
                            _c("icon", {
                              attrs: {
                                name: "yotpo-thumbsdown",
                                width: "24px",
                                height: "24px",
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "yotpo-reviews__review-rating-amount",
                              },
                              [_vm._v(_vm._s(review.votes_down))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }